import { fetchTotalDraftCounter } from '@api';
import { CounterDraft } from '@domain/types';
import { logger } from '@services/logger/logger.service';
import { put, select, takeLatest } from 'redux-saga/effects';

import { selectIsDraftCounterStale } from '../draft.selector';
import { DraftDocumentsActions } from '../draft.slice';

function* getTotalDraftSaga(action: ReturnType<typeof DraftDocumentsActions.fetchDraftCounters>) {
  // Check if cache is still fresh (TTL-based caching) — unless the caller already knows the cached
  // number is wrong (`force`) and has no delta of its own to patch it with.
  const isStale: boolean = yield select(selectIsDraftCounterStale);
  if (!isStale && !action.payload?.force) {
    logger.debug('LOGIC', 'Draft counter cache is still fresh, skipping fetch');
    return;
  }

  try {
    const result: CounterDraft = yield fetchTotalDraftCounter();
    yield put(DraftDocumentsActions.fetchDraftCounterSuccess(result));
  } catch (error) {
    logger.error('LOGIC', 'Failed to get total draft counter', error);
    yield put(DraftDocumentsActions.fetchDraftCounterFailure({ error }));
  }
}

export function* draftDocumentsCountersSagas() {
  yield takeLatest(DraftDocumentsActions.fetchDraftCounters.type, getTotalDraftSaga);
}
